import { render } from "./dash-footer.vue?vue&type=template&id=0d009f12&scoped=true"
import script from "./dash-footer.vue?vue&type=script&lang=js"
export * from "./dash-footer.vue?vue&type=script&lang=js"

import "@/assets/css/dashStyle.css?vue&type=style&index=0&id=0d009f12&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0d009f12"]])

export default __exports__